"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _toaster_container = _interopRequireDefault(require("../../message/toaster/toaster_container"));

var _notification_container = _interopRequireDefault(require("../../message/notification/notification_container"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _messageholder_styles = _interopRequireDefault(require("./messageholder_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// components
// styles

/* ========== ~~~~~~~~~~ EXPORT : MESSAGE HOLDER ~~~~~~~~~~ ========== */


var _default = (0, _reactJss.default)(_messageholder_styles.default)(function (props) {
  var _renderTopNotifications = function _renderTopNotifications() {
    return props.notification.top.map(function (message) {
      return _react.default.createElement(_notification_container.default, {
        key: message.id,
        message: message
      });
    });
  };

  var _renderBottomNotifications = function _renderBottomNotifications() {
    return props.notification.bottom.map(function (message) {
      return _react.default.createElement(_notification_container.default, {
        key: message.id,
        message: message
      });
    });
  }; // RENDER TOP TOASTERS


  var _renderTopRightToasters = function _renderTopRightToasters() {
    return props.toaster.top.reduce(function (accumulator, message) {
      return message.align.includes('right') ? accumulator.concat([_react.default.createElement(_toaster_container.default, {
        key: message.id,
        message: message
      })]) : accumulator;
    }, []);
  };

  var _renderTopLeftToasters = function _renderTopLeftToasters() {
    return props.toaster.top.reduce(function (accumulator, message) {
      return message.align.includes('left') ? accumulator.concat([_react.default.createElement(_toaster_container.default, {
        key: message.id,
        message: message
      })]) : accumulator;
    }, []);
  }; // RENDER BOTTOM TOASTERS


  var _renderBottomRightToasters = function _renderBottomRightToasters() {
    return props.toaster.bottom.reduce(function (accumulator, message) {
      return message.align.includes('right') ? accumulator.concat([_react.default.createElement(_toaster_container.default, {
        key: message.id,
        message: message
      })]) : accumulator;
    }, []);
  };

  var _renderBottomLeftToasters = function _renderBottomLeftToasters() {
    return props.toaster.bottom.reduce(function (accumulator, message) {
      return message.align.includes('left') ? accumulator.concat([_react.default.createElement(_toaster_container.default, {
        key: message.id,
        message: message
      })]) : accumulator;
    }, []);
  };

  return _react.default.createElement("div", {
    id: "messageholder",
    className: "structure messageholder ".concat(props.classes.messageHolder)
  }, _react.default.createElement("div", {
    className: "messages top"
  }, _renderTopNotifications(), _react.default.createElement("div", {
    className: "toastermessages right"
  }, _renderTopRightToasters()), _react.default.createElement("div", {
    className: "toastermessages left"
  }, _renderTopLeftToasters())), _react.default.createElement("div", {
    className: "messages bottom"
  }, _react.default.createElement("div", {
    className: "toastermessages right"
  }, _renderBottomRightToasters()), _react.default.createElement("div", {
    className: "toastermessages left"
  }, _renderBottomLeftToasters()), _renderBottomNotifications()));
});

exports.default = _default;